module.exports = __webpack_public_path__ + "img/arrow-left.6b958969.svg";